import { kebabCase } from 'lodash';
import { i18nMark } from 'lingui-react';

import buildEnum from 'utils/buildEnum';

import { USER_ROLES } from 'features/rbac';

export const reportTypes = buildEnum(
  [
    'caseBillingReport',
    'casesPerHour',
    'dailyAgentMetrics',
    'dailyCasesMetrics',
    'dailyDealerReport',
    'dailyDealerReportByEmail',
    'emailDistributionReport',
    'dealerSelectionAuditReport',
    'assetValidationReport',
  ],
  // Because we use these values in the URL,
  // we want them prettier than the default.
  kebabCase,
);

export const reportTitles = {
  [reportTypes.caseBillingReport]: i18nMark('Case Billing Report'),
  [reportTypes.casesPerHour]: i18nMark('Cases Per Hour'),
  [reportTypes.dailyAgentMetrics]: i18nMark('Daily Agent Metrics'),
  [reportTypes.dailyCasesMetrics]: i18nMark('Daily Cases Metrics'),
  [reportTypes.dailyDealerReport]: i18nMark('Daily Service Provider Report'),
  [reportTypes.dailyDealerReportByEmail]: i18nMark(
    'Daily Service Provider Report',
  ),
  [reportTypes.emailDistributionReport]: i18nMark(
    'Email Notification Distribution Report',
  ),
  [reportTypes.dealerSelectionAuditReport]: i18nMark(
    'Service Provider Selection Audit Report',
  ),
  [reportTypes.assetValidationReport]: i18nMark('Asset Validation Report'),
};

export const dealerRoles = [USER_ROLES.DEALER_USER, USER_ROLES.DEALER_ADMIN];
export const dealersAllowedReportTypes = [reportTypes.dailyDealerReportByEmail];

export const nonDealersAllowedReportTypes = [
  reportTypes.caseBillingReport,
  reportTypes.casesPerHour,
  reportTypes.dailyAgentMetrics,
  reportTypes.dailyCasesMetrics,
  reportTypes.dailyDealerReport,
  reportTypes.emailDistributionReport,
  reportTypes.dealerSelectionAuditReport,
  reportTypes.assetValidationReport,
];

export const michelinOpsAllowedReportTypes = [
  reportTypes.dailyCasesMetrics,
  reportTypes.dailyDealerReport,
  reportTypes.emailDistributionReport,
  reportTypes.dealerSelectionAuditReport,
  reportTypes.assetValidationReport,
];



// WEBPACK FOOTER //
// ./src/pages/Reports/constants.js